import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import PageContent from './PageContent'
import PageHeader from './_shared/PageHeader'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const TemplateTembiciPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <PageHeader templateId={parseInt(templateId)} />
        <PageContent templateId={parseInt(templateId)} />
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplateTembiciPdfPage
